<template>
  <div class="calendar-icon">
    <div class="calendar-ring"></div>
    <div class="calendar-ring"></div>
    <img src="@/assets/icons/calendar_date_150.png"/>
  </div>
</template>

<style lang="scss" scoped>
.calendar-icon {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 8fr;
  justify-items: center;
}

.calendar-ring {
  position: relative;
  width: 12%;
  height: 100%;
  z-index: 1;
}

.calendar-ring::before {
  position: absolute;  
  content: '';
  width: 100%;
  height: 200%;
  border-radius: 50% / 15%;
  background-color: #888;
}

img {
  grid-column: 1 / span 2;
  border-radius: 6%;
  border: 1px solid #ccc;
  background-color: #fff;
  width: 100%;
  padding: 12%;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
}
</style>
